import { NFLookupCatalog } from "./NFLookupCatalog";
import { AppEntities } from "../../../config/entities";
import { NFLookupCatalogColumn } from "./NFLookupCatalogColumn";
import React from "react";

interface IProps {
  title?: string;
  fieldName: string;
  required?: boolean;
  width?: number;
  showBorder?: boolean;
  selectedCatalog?: boolean;
  setSelectedCatalog?: (value: boolean) => void;
}

export const NFLookupCashflowItem = ({ title, fieldName, required, width, showBorder, selectedCatalog, setSelectedCatalog }: IProps) => {
  const loadData = async (searchText: string | undefined) => {
    return await AppEntities.CashflowItem.getDataService().GetAll(searchText);
  };

  return (
    <>
      <NFLookupCatalog
        fieldName={fieldName}
        title={title}
        entity={AppEntities.CashflowItem}
        serverData={loadData}
        required={required}
        showBorder={showBorder}
        width={width}
        selectedCatalog={selectedCatalog}
        setSelectedCatalog={setSelectedCatalog}
      >
        <NFLookupCatalogColumn fieldName={"id"} caption={"Id"} />
        <NFLookupCatalogColumn fieldName={"name"} caption={"Name"} />
      </NFLookupCatalog>
    </>
  );
};
